import { render, staticRenderFns } from "./gradient-button.vue?vue&type=template&id=6a8d7b80&scoped=true"
import script from "./gradient-button.vue?vue&type=script&lang=js"
export * from "./gradient-button.vue?vue&type=script&lang=js"
import style0 from "./gradient-button.vue?vue&type=style&index=0&id=6a8d7b80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8d7b80",
  null
  
)

export default component.exports